export const API_URL = "https://webauth.bintangwistar.my.id/apiweb/";
